import { Weekday } from "@tento-chrono";

export function orderedWeekdays(startOfWeek: Weekday): Weekday[] {
  const weekdays = Weekday.DOW1;
  const startIndex = weekdays.indexOf(startOfWeek);
  if (startIndex < 0) return [...weekdays];
  return [...weekdays.slice(startIndex), ...weekdays.slice(0, startIndex)];
}

export function shortWeekdayLabels(startOfWeek: Weekday): string[] {
  return orderedWeekdays(startOfWeek).map((weekday) => weekday.shortname);
}
